module.exports = __webpack_public_path__ + "img/_85C9083.16314f4b.jpeg";